/*
 * Product Comparison Deluxe — extracted inline JS for
 * sections/product-comparison-deluxe.liquid (mobile competitor carousel).
 * Each section root carries data-product-comparison-deluxe-config-id which
 * references a JSON <script> config block.
 */
(function () {
  function boot(sectionEl) {
    if (!sectionEl) return false;
    if (sectionEl.getAttribute('data-carousel-ready')) return false;

    var configId = sectionEl.dataset.productComparisonDeluxeConfigId;
    var configEl = configId ? document.getElementById(configId) : null;
    if (!configEl) return false;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return false; }

    sectionEl.setAttribute('data-carousel-ready', '1');

    var totalCompetitors = cfg.totalCompetitors || 0;
    var mobileGridGap = (typeof cfg.mobileGridGap === 'number') ? cfg.mobileGridGap : 2;
    var mobileTableInset = (typeof cfg.mobileTableInset === 'number') ? cfg.mobileTableInset : 6;

    var wrapper = sectionEl.querySelector('.comparison-table-wrapper');
    var table = sectionEl.querySelector('.comparison-table');
    var dotsWrap = sectionEl.querySelector('.carousel-dots');
    if (!wrapper || !table) return false;

    function isMobile() { return window.innerWidth <= 749; }

    var _compW = 0;
    var _gap = mobileGridGap;
    var _currentIdx = 0;
    var _isAnimating = false;
    var colFeat = table.querySelector('.col-feature');
    var colHL = table.querySelector('.col-highlighted');
    var colComps = table.querySelectorAll('.col-competitor');

    /* All competitor header + body cells for transform */
    var compCells = table.querySelectorAll('.competitor-col');

    function measure() {
      if (!isMobile()) return;
      var inset = mobileTableInset;
      var vw = document.documentElement.clientWidth;
      var w = vw - (inset * 2);
      var gap = _gap;
      /* 3 visible columns: feat + hl + 1 comp */
      var totalGaps = 4 * gap;
      var available = w - totalGaps;
      var colW = Math.floor(available / 3);
      var featW = colW;
      var hlW = colW;
      var compW = available - featW - hlW;
      _compW = compW;

      wrapper.style.setProperty('--c-feat-w', featW + 'px');
      wrapper.style.setProperty('--c-hl-w', hlW + 'px');
      wrapper.style.setProperty('--c-comp-w', compW + 'px');

      if (colFeat) colFeat.style.width = featW + 'px';
      if (colHL) colHL.style.width = hlW + 'px';
      for (var c = 0; c < colComps.length; c++) {
        colComps[c].style.width = compW + 'px';
      }

      /* Table only needs to fit 3 columns (feat + hl + 1 comp slot) */
      var tableW = featW + hlW + compW + (4 * gap);
      table.style.width = tableW + 'px';
      wrapper.style.width = w + 'px';

      /* Apply current position */
      setOffset(_currentIdx * (_compW + _gap), false);
      updateDots();
    }

    /* --- Translate all competitor cells by a pixel offset --- */
    function setOffset(px, animate) {
      var val = 'translateX(' + (-px) + 'px)';
      for (var i = 0; i < compCells.length; i++) {
        compCells[i].style.transition = animate ? 'transform 0.3s ease-out' : 'none';
        compCells[i].style.transform = val;
      }
    }

    /* --- Go to competitor index (0-based), clamped --- */
    function goTo(idx, animate) {
      idx = Math.max(0, Math.min(idx, totalCompetitors - 1));
      _currentIdx = idx;
      var offset = idx * (_compW + _gap);

      if (!animate) {
        setOffset(offset, false);
        updateDots();
        return;
      }

      _isAnimating = true;
      setOffset(offset, true);
      updateDots();

      /* Clear animation flag after transition */
      setTimeout(function () {
        _isAnimating = false;
        /* Remove transition to prevent interference with drag */
        for (var i = 0; i < compCells.length; i++) {
          compCells[i].style.transition = 'none';
        }
      }, 320);
    }

    function updateDots() {
      if (!dotsWrap) return;
      var btns = dotsWrap.querySelectorAll('.carousel-dot');
      for (var i = 0; i < btns.length; i++) {
        var di = parseInt(btns[i].getAttribute('data-index'), 10);
        btns[i].classList.toggle('active', di === _currentIdx + 1);
      }
    }

    /* --- Dot clicks --- */
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var btn = e.target;
        while (btn && btn !== dotsWrap && !btn.classList.contains('carousel-dot')) {
          btn = btn.parentNode;
        }
        if (!btn || !btn.classList.contains('carousel-dot')) return;
        if (!isMobile() || _isAnimating) return;
        e.preventDefault();
        var ni = parseInt(btn.getAttribute('data-index'), 10);
        if (!isNaN(ni)) goTo(ni - 1, true);
      });
    }

    /* --- Touch / pointer swipe — only on competitor cells --- */
    (function () {
      var isDragging = false;
      var startX = 0;
      var startOffset = 0;
      var dragDelta = 0;

      function isCompetitorArea(el) {
        while (el && el !== wrapper) {
          if (el.classList && el.classList.contains('competitor-col')) return true;
          el = el.parentNode;
        }
        return false;
      }

      wrapper.addEventListener('pointerdown', function (e) {
        if (!isMobile() || _isAnimating) return;
        if (e.button !== 0) return;
        if (!isCompetitorArea(e.target)) return;
        isDragging = true;
        startX = e.clientX;
        startOffset = _currentIdx * (_compW + _gap);
        dragDelta = 0;
        wrapper.setPointerCapture(e.pointerId);
        e.preventDefault();
      });

      wrapper.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        dragDelta = startX - e.clientX;
        /* Clamp so you can't drag past the first or last */
        var maxOffset = (totalCompetitors - 1) * (_compW + _gap);
        var newOffset = Math.max(0, Math.min(startOffset + dragDelta, maxOffset));
        setOffset(newOffset, false);
      });

      function endDrag(e) {
        if (!isDragging) return;
        isDragging = false;
        wrapper.releasePointerCapture(e.pointerId);

        var threshold = _compW * 0.25;
        var newIdx = _currentIdx;
        if (dragDelta > threshold) {
          newIdx = _currentIdx + 1;
        } else if (dragDelta < -threshold) {
          newIdx = _currentIdx - 1;
        }
        goTo(newIdx, true);
      }

      wrapper.addEventListener('pointerup', endDrag);
      wrapper.addEventListener('pointercancel', endDrag);
      wrapper.addEventListener('dragstart', function (e) {
        if (isDragging) e.preventDefault();
      });
    })();

    /* --- Init --- */
    measure();

    /* --- Resize --- */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (isMobile()) {
          measure();
        } else {
          table.style.width = '';
          wrapper.style.width = '';
          wrapper.style.removeProperty('--c-feat-w');
          wrapper.style.removeProperty('--c-hl-w');
          wrapper.style.removeProperty('--c-comp-w');
          if (colFeat) colFeat.style.width = '';
          if (colHL) colHL.style.width = '';
          for (var c = 0; c < colComps.length; c++) colComps[c].style.width = '';
          for (var i = 0; i < compCells.length; i++) {
            compCells[i].style.transform = '';
            compCells[i].style.transition = '';
          }
        }
      }, 150);
    });

    return true;
  }

  function bootAll() {
    document.querySelectorAll('[data-product-comparison-deluxe-config-id]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('[data-product-comparison-deluxe-config-id]') : null;
    if (s) { s.removeAttribute('data-carousel-ready'); boot(s); }
    else { bootAll(); }
  });
})();
